// tslint:disable
/**
 * PicsArt Web Video Editor (api)
 * PicsArt Web Video Editor API
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: dmitry.maksakov@picsart.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * Represents video, picture or audio in our CDN
 * @export
 * @interface AddContentResponse
 */
export interface AddContentResponse {
  /**
   *
   * @type {ContentItem}
   * @memberof AddContentResponse
   */
  result: ContentItem;
  /**
   * Status
   * @type {boolean}
   * @memberof AddContentResponse
   */
  status: boolean;
}
/**
 * Describes various backend settings
 * @export
 * @interface BackendSettings
 */
export interface BackendSettings {
  /**
   *
   * @type {TransitionSettings}
   * @memberof BackendSettings
   */
  transitions: TransitionSettings;
}
/**
 * Represents video, picture or audio in our CDN
 * @export
 * @interface ContentItem
 */
export interface ContentItem {
  /**
   * For sending to backend and saving to our PA entities only
   * @type {string}
   * @memberof ContentItem
   */
  url: string;
  /**
   * For downloading the actual file
   * @type {string}
   * @memberof ContentItem
   */
  download_url?: string;
}
/**
 * Crop rectangle area, draw by diagonal from top left to bottom right corner
 * @export
 * @interface Crop
 */
export interface Crop {
  /**
   *
   * @type {Position}
   * @memberof Crop
   */
  topLeft: Position;
  /**
   *
   * @type {Position}
   * @memberof Crop
   */
  bottomRight: Position;
}
/**
 * Describes point position on canvas.
 * @export
 * @interface Dimensions
 */
export interface Dimensions {
  /**
   * Width of the block
   * @type {number}
   * @memberof Dimensions
   */
  width?: number;
  /**
   * Height of the block
   * @type {number}
   * @memberof Dimensions
   */
  height?: number;
}
/**
 * Describes an effect to the video or image.
 * @export
 * @interface Effect
 */
export interface Effect {
  /**
   * Name of the effect.
   * @type {string}
   * @memberof Effect
   */
  name: string;
}
/**
 * font_resource
 * @export
 * @interface FontResource
 */
export interface FontResource {
  /**
   * resource_url
   * @type {string}
   * @memberof FontResource
   */
  resource_url?: string;
}
/**
 * raised when payload didn\'t match the schema
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
  /**
   * describes all validation errors
   * @type {Array<ValidationError>}
   * @memberof HTTPValidationError
   */
  detail?: Array<ValidationError>;
}
/**
 * Base Layer fields.
 * @export
 * @interface Layer
 */
export interface Layer {
  /**
   * Content type.
   * @type {string}
   * @memberof Layer
   */
  type: string;
  /**
   * Clip geometry transformations.
   * @type {Transform}
   * @memberof Layer
   */
  transform: Transform;
  /**
   * Effects, which should be seen only on specific layer. All values relative to scene.
   * @type {Array<Effect>}
   * @memberof Layer
   */
  effects?: Array<Effect>;
  /**
   * Crop rectangle what will be apply to current scene.
   * @type {Crop}
   * @memberof Layer
   */
  crop?: Crop;
  /**
   * Text will start displaying at this time (from the whole video beginning), ms
   * @type {number}
   * @memberof Layer
   */
  timeStart?: number;
  /**
   * Text will finish displaying at this time (from the whole video beginning), ms
   * @type {number}
   * @memberof Layer
   */
  timeEnd: number;
}
/**
 * License
 * @export
 * @enum {string}
 */
export enum LicenseEnum {
  Premium = 'premium',
  Fte = 'fte'
}

/**
 * Layers on a canvas, like video, image or gif.
 * @export
 * @interface MediaLayer
 */
export interface MediaLayer extends Layer {
  /**
   * Describes fields that allow get media data from CDN and apply custom trim.
   * @type {ContentItem | TrimmedContentItem}
   * @memberof MediaLayer
   */
  content: ContentItem | TrimmedContentItem;
  /**
   *
   * @type {MediaLayerTypeEnum}
   * @memberof MediaLayer
   */
  type: MediaLayerTypeEnum;
  /**
   * Describes if the video sound is muted (default – false).
   * @type {boolean}
   * @memberof MediaLayer
   */
  isMuted?: boolean;
}
/**
 * Describes the type of the layer.
 * @export
 * @enum {string}
 */
export enum MediaLayerTypeEnum {
  Image = 'image',
  Video = 'video'
}

/**
 * Describes point position on canvas.
 * @export
 * @interface Position
 */
export interface Position {
  /**
   * Coordinate \"x\" of the left top corner.
   * @type {number}
   * @memberof Position
   */
  x?: number;
  /**
   * Coordinate \"y\" of the left top corner.
   * @type {number}
   * @memberof Position
   */
  y?: number;
}
/**
 * Describes how to preprocess the content
 * @export
 * @interface PreprocessingTask
 */
export interface PreprocessingTask {
  /**
   *
   * @type {ContentItem}
   * @memberof PreprocessingTask
   */
  content?: ContentItem;
}
/**
 * Describes information about the output video
 * @export
 * @interface ProcessingResult
 */
export interface ProcessingResult {
  /**
   * URL of the processed video
   * @type {string}
   * @memberof ProcessingResult
   */
  url: string;
}
/**
 * Describes how to process the content to the final video
 * @export
 * @interface ProcessingTask
 */
export interface ProcessingTask {
  /**
   * Ordered list of content with transitions info
   * @type {Array<Scene>}
   * @memberof ProcessingTask
   */
  scenes: Array<Scene>;
  /**
   *
   * @type {ContentItem | TrimmedContentItem}
   * @memberof ProcessingTask
   */
  audio?: ContentItem | TrimmedContentItem;
  /**
   *
   * @type {TargetSettings}
   * @memberof ProcessingTask
   */
  targetSettings: TargetSettings;
}
/**
 * Describes information about final video processing
 * @export
 * @interface ProcessingTaskStatus
 */
export interface ProcessingTaskStatus {
  /**
   * Processing status
   * @type {string}
   * @memberof ProcessingTaskStatus
   */
  status: ProcessingTaskStatusStatusEnum;
  /**
   * Processing progress in %
   * @type {number}
   * @memberof ProcessingTaskStatus
   */
  progress?: number;
  /**
   * Processing error message
   * @type {string}
   * @memberof ProcessingTaskStatus
   */
  error?: string;
  /**
   *
   * @type {ProcessingResult}
   * @memberof ProcessingTaskStatus
   */
  result?: ProcessingResult;
}

/**
 * @export
 * @enum {string}
 */
export enum ProcessingTaskStatusStatusEnum {
  Running = 'running',
  Done = 'done',
  Error = 'error',
  Stopped = 'stopped',
  Queued = 'queued'
}

/**
 * Describes how to scale the scene if the original and final ARs don\'t match (default – \"fit\")
 * @export
 * @enum {string}
 */
export enum ScalingModeEnum {
  Fit = 'fit',
  Fill = 'fill'
}

/**
 * Represents a scene – image or video with effects and transition information
 * @export
 * @interface Scene
 */
export interface Scene {
  /**
   * List of objects on a scene, like videos, images, gifs.
   * @type {Array<MediaLayer | TextLayer>}
   * @memberof Scene
   */
  layers: Array<MediaLayer | TextLayer>;
  /**
   * Effects, which should be seen only on specific scene. All values relative to scene.
   * @type {Array<Effect>}
   * @memberof Scene
   */
  effects?: Array<Effect>;
  /**
   * Transition that happens at the end of the scene and on the start of the next scene. Will be ignored for the last scene.
   * @type {Transition}
   * @memberof Scene
   */
  transition?: Transition;
  /**
   * Describes if the video sound is muted (default – false).
   * @type {boolean}
   * @memberof Scene
   */
  isMuted?: boolean;
}
/**
 * Shutterstock image
 * @export
 * @interface ShutterstockImage
 */
export interface ShutterstockImage {
  /**
   * id
   * @type {string}
   * @memberof ShutterstockImage
   */
  id?: string;
  /**
   * url
   * @type {string}
   * @memberof ShutterstockImage
   */
  url?: string;
}
/**
 * Shutterstock response
 * @export
 * @interface ShutterstockResponse
 */
export interface ShutterstockResponse {
  /**
   *
   * @type {ShutterstockResponseItem}
   * @memberof ShutterstockResponse
   */
  response: ShutterstockResponseItem;
  /**
   * Status
   * @type {boolean}
   * @memberof ShutterstockResponse
   */
  status: boolean;
}
/**
 * Shutterstock response item
 * @export
 * @interface ShutterstockResponseItem
 */
export interface ShutterstockResponseItem {
  /**
   * Shutterstock response data
   * @type {Array<ShutterstockImage>}
   * @memberof ShutterstockResponseItem
   */
  data?: Array<ShutterstockImage>;
}
/**
 * Stock video
 * @export
 * @interface StockVideo
 */
export interface StockVideo {
  /**
   * Allowed for commercial use or not
   * @type {boolean}
   * @memberof StockVideo
   */
  commercial: boolean;
  /**
   * Url to CDN of video of original size
   * @type {string}
   * @memberof StockVideo
   */
  url: string;
  /**
   * List of tags
   * @type {Array<string>}
   * @memberof StockVideo
   */
  tags: Array<string>;
  /**
   *
   * @type {LicenseEnum}
   * @memberof StockVideo
   */
  license: LicenseEnum;
  /**
   *
   * @type {VideoDescription}
   * @memberof StockVideo
   */
  preview_small: VideoDescription;
  /**
   *
   * @type {VideoDescription}
   * @memberof StockVideo
   */
  preview_medium: VideoDescription;
  /**
   *
   * @type {VideoDescription}
   * @memberof StockVideo
   */
  preview_big: VideoDescription;
  /**
   * Url to CDN of thumbnail image
   * @type {string}
   * @memberof StockVideo
   */
  thumbnail_url: string;
  /**
   * Video id
   * @type {string}
   * @memberof StockVideo
   */
  _id: string;
}
/**
 * Describes request to create preview and thumbnail for a given stockvideo item
 * @export
 * @interface StockVideoTask
 */
export interface StockVideoTask {
  /**
   * Url to CDN of video of original size
   * @type {string}
   * @memberof StockVideoTask
   */
  url?: string;
  /**
   * Url to CDN of thumbnail image
   * @type {string}
   * @memberof StockVideoTask
   */
  thumbnail_url?: string;
  /**
   *
   * @type {VideoDescription}
   * @memberof StockVideoTask
   */
  preview_small?: VideoDescription;
  /**
   *
   * @type {VideoDescription}
   * @memberof StockVideoTask
   */
  preview_medium?: VideoDescription;
  /**
   *
   * @type {VideoDescription}
   * @memberof StockVideoTask
   */
  preview_big?: VideoDescription;
}
/**
 * Response
 * @export
 * @interface StockVideosList
 */
export interface StockVideosList {
  /**
   *
   * @type {StockVideosListMetadata}
   * @memberof StockVideosList
   */
  metadata?: StockVideosListMetadata;
  /**
   * List of stock videos
   * @type {Array<StockVideo>}
   * @memberof StockVideosList
   */
  response?: Array<StockVideo>;
  /**
   * Status
   * @type {string}
   * @memberof StockVideosList
   */
  status?: StockVideosListStatusEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum StockVideosListStatusEnum {
  Success = 'success'
}

/**
 * Metadata
 * @export
 * @interface StockVideosListMetadata
 */
export interface StockVideosListMetadata {
  /**
   * Next page url
   * @type {string}
   * @memberof StockVideosListMetadata
   */
  next_page?: string;
}
/**
 * Describes a format for the output video
 * @export
 * @interface TargetSettings
 */
export interface TargetSettings extends Dimensions {
  /**
   *
   * @type {VideoFileContainerEnum}
   * @memberof TargetSettings
   */
  container?: VideoFileContainerEnum;
  /**
   * Describes the prefix of the name. Filename will be as follows \"<namePrefix>_<GUID>.<extension>\". Name prefix shouldn\'t include \"/\\|~`\'\":;.,*<>\"
   * @type {string}
   * @memberof TargetSettings
   */
  namePrefix?: string;
  /**
   * Effects list. All values are relative to the whole video.
   * @type {Array<Effect>}
   * @memberof TargetSettings
   */
  effects?: Array<Effect>;
  /**
   * Media content resolution.
   * @type {string}
   * @memberof TargetSettings
   */
  resolution?: string;
}
/**
 * Information about task
 * @export
 * @interface Task
 */
export interface Task {
  /**
   * ID of the task
   * @type {string}
   * @memberof Task
   */
  taskId: string;
}
/**
 * Size and url of video
 * @export
 * @interface Templates
 */
export interface Templates extends Dimensions {
  /**
   * Identifier
   * @type {string}
   * @memberof Templates
   */
  id?: string;
  /**
   * For commercial use or not
   * @type {boolean}
   * @memberof Templates
   */
  commercial?: boolean;
  /**
   *
   * @type {LicenseEnum}
   * @memberof Templates
   */
  license?: LicenseEnum;
  /**
   * Url to stored template
   * @type {string}
   * @memberof Templates
   */
  url: string;
  /**
   * Url to stored preview video
   * @type {string}
   * @memberof Templates
   */
  preview_url?: string;
  /**
   * Url to stored thumbnail image
   * @type {string}
   * @memberof Templates
   */
  thumbnail_url?: string;
  /**
   * Array of tags
   * @type {Array<string>}
   * @memberof Templates
   */
  tags?: Array<string>;
}
/**
 * Response
 * @export
 * @interface TemplatesList
 */
export interface TemplatesList {
  /**
   *
   * @type {StockVideosListMetadata}
   * @memberof TemplatesList
   */
  metadata?: StockVideosListMetadata;
  /**
   * List of templates
   * @type {Array<Templates>}
   * @memberof TemplatesList
   */
  response?: Array<Templates>;
  /**
   * Status
   * @type {string}
   * @memberof TemplatesList
   */
  status?: TemplatesListStatusEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum TemplatesListStatusEnum {
  Success = 'success'
}

/**
 * Describes canvas text layer.
 * @export
 * @interface TextLayer
 */
export interface TextLayer extends Layer {
  /**
   *
   * @type {TextLayerTypeEnum}
   * @memberof TextLayer
   */
  type: TextLayerTypeEnum;
  /**
   *
   * @type {string}
   * @memberof TextLayer
   */
  text?: string;
  /**
   *
   * @type {TextLayerGeometry}
   * @memberof TextLayer
   */
  geometry?: TextLayerGeometry;
  /**
   *
   * @type {TextLayerFontStyle}
   * @memberof TextLayer
   */
  fontStyle?: TextLayerFontStyle;
  /**
   *
   * @type {TextLayerColorStyle}
   * @memberof TextLayer
   */
  colorStyle?: TextLayerColorStyle;
  /**
   *
   * @type {TextLayerOutlineStyle}
   * @memberof TextLayer
   */
  outlineStyle?: TextLayerOutlineStyle;
  /**
   *
   * @type {TextLayerShadowStyle}
   * @memberof TextLayer
   */
  shadowStyle?: TextLayerShadowStyle;
  /**
   *
   * @type {TextLayerAnimation}
   * @memberof TextLayer
   */
  animation?: TextLayerAnimation;
}
/**
 *
 * @export
 * @interface TextLayerAnimation
 */
export interface TextLayerAnimation {
  /**
   * animation name
   * @type {string}
   * @memberof TextLayerAnimation
   */
  name: TextLayerAnimationNameEnum;
  /**
   * to specify, for example, \'fade in\' or \'fade out\'. Applicable for \'fade\', \'fly\', \'zoom\'
   * @type {string}
   * @memberof TextLayerAnimation
   */
  timeDirection?: TextLayerAnimationTimeDirectionEnum;
  /**
   * direction of animation. left/right/tob/bottom are for \'fly\'; \'cw\' and \'ccw\' are for \'spin\'
   * @type {string}
   * @memberof TextLayerAnimation
   */
  direction?: TextLayerAnimationDirectionEnum;
  /**
   * duration in ms. Applicable for all except \'typing\'
   * @type {number}
   * @memberof TextLayerAnimation
   */
  duration?: number;
  /**
   * spinning rate for spinning animation. Rotations per second
   * @type {number}
   * @memberof TextLayerAnimation
   */
  spinRate?: number;
  /**
   * symbols per second for \'typing\' animation
   * @type {number}
   * @memberof TextLayerAnimation
   */
  symbolRate?: number;
  /**
   * show cursor during typing animation
   * @type {boolean}
   * @memberof TextLayerAnimation
   */
  showCursor?: boolean;
  /**
   * loop, keep or hide text after the animation finishes. Applicable for \'typing\'
   * @type {string}
   * @memberof TextLayerAnimation
   */
  after?: TextLayerAnimationAfterEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum TextLayerAnimationNameEnum {
  Typing = 'typing',
  Fade = 'fade',
  Fly = 'fly',
  Zoom = 'zoom',
  Spin = 'spin'
}
/**
 * @export
 * @enum {string}
 */
export enum TextLayerAnimationTimeDirectionEnum {
  In = 'in',
  Out = 'out'
}
/**
 * @export
 * @enum {string}
 */
export enum TextLayerAnimationDirectionEnum {
  Left = 'left',
  Right = 'right',
  Top = 'top',
  Bottom = 'bottom',
  Cw = 'cw',
  Ccw = 'ccw'
}
/**
 * @export
 * @enum {string}
 */
export enum TextLayerAnimationAfterEnum {
  Loop = 'loop',
  Keep = 'keep',
  Hide = 'hide'
}

/**
 *
 * @export
 * @interface TextLayerColorStyle
 */
export interface TextLayerColorStyle {
  /**
   * hex rgba
   * @type {string}
   * @memberof TextLayerColorStyle
   */
  textColor: string;
  /**
   * hex rgba
   * @type {string}
   * @memberof TextLayerColorStyle
   */
  background?: string;
}
/**
 *
 * @export
 * @interface TextLayerFontStyle
 */
export interface TextLayerFontStyle {
  /**
   *
   * @type {string}
   * @memberof TextLayerFontStyle
   */
  family_name?: string;
  /**
   *
   * @type {string}
   * @memberof TextLayerFontStyle
   */
  family: string;
  /**
   *
   * @type {number}
   * @memberof TextLayerFontStyle
   */
  size: number;
  /**
   *
   * @type {boolean}
   * @memberof TextLayerFontStyle
   */
  isBold?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof TextLayerFontStyle
   */
  isItalic?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof TextLayerFontStyle
   */
  isUnderline?: boolean;
  /**
   *
   * @type {number}
   * @memberof TextLayerFontStyle
   */
  letterSpacing?: number;
  /**
   *
   * @type {number}
   * @memberof TextLayerFontStyle
   */
  lineHeight?: number;
  /**
   *
   * @type {string}
   * @memberof TextLayerFontStyle
   */
  xAlign?: TextLayerFontStyleXAlignEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum TextLayerFontStyleXAlignEnum {
  Left = 'left',
  Center = 'center',
  Right = 'right',
  Justify = 'justify'
}

/**
 *
 * @export
 * @interface TextLayerGeometry
 */
export interface TextLayerGeometry {
  /**
   * Coordinate \"x\" of the left top corner.
   * @type {number}
   * @memberof TextLayerGeometry
   */
  x: number;
  /**
   * Coordinate \"y\" of the left top corner.
   * @type {number}
   * @memberof TextLayerGeometry
   */
  y: number;
  /**
   * Width of the block
   * @type {number}
   * @memberof TextLayerGeometry
   */
  width: number;
  /**
   * Height of the block
   * @type {number}
   * @memberof TextLayerGeometry
   */
  height?: number;
}
/**
 *
 * @export
 * @interface TextLayerOutlineStyle
 */
export interface TextLayerOutlineStyle {
  /**
   * hex rgba
   * @type {string}
   * @memberof TextLayerOutlineStyle
   */
  color: string;
  /**
   *
   * @type {number}
   * @memberof TextLayerOutlineStyle
   */
  size: number;
}
/**
 *
 * @export
 * @interface TextLayerShadowStyle
 */
export interface TextLayerShadowStyle {
  /**
   * hex rgba
   * @type {string}
   * @memberof TextLayerShadowStyle
   */
  color: string;
  /**
   *
   * @type {number}
   * @memberof TextLayerShadowStyle
   */
  xOffset?: number;
  /**
   *
   * @type {number}
   * @memberof TextLayerShadowStyle
   */
  yOffset?: number;
  /**
   *
   * @type {number}
   * @memberof TextLayerShadowStyle
   */
  blur?: number;
}
/**
 * Describes the type of the layer.
 * @export
 * @enum {string}
 */
export enum TextLayerTypeEnum {
  Text = 'text'
}

/**
 * Text template content item
 * @export
 * @interface TextTemplateContentItem
 */
export interface TextTemplateContentItem {
  /**
   * className
   * @type {string}
   * @memberof TextTemplateContentItem
   */
  className?: TextTemplateContentItemClassNameEnum;
  /**
   *
   * @type {TextTemplateContentItemAttrs}
   * @memberof TextTemplateContentItem
   */
  attrs?: TextTemplateContentItemAttrs;
}

/**
 * @export
 * @enum {string}
 */
export enum TextTemplateContentItemClassNameEnum {
  Text = 'Text'
}

/**
 * attrs
 * @export
 * @interface TextTemplateContentItemAttrs
 */
export interface TextTemplateContentItemAttrs {
  /**
   * text
   * @type {string}
   * @memberof TextTemplateContentItemAttrs
   */
  text: string;
  /**
   * fontFamily
   * @type {string}
   * @memberof TextTemplateContentItemAttrs
   */
  fontFamily: string;
  /**
   *
   * @type {FontResource}
   * @memberof TextTemplateContentItemAttrs
   */
  font_resource: FontResource;
  /**
   * fontSize
   * @type {number}
   * @memberof TextTemplateContentItemAttrs
   */
  fontSize: number;
  /**
   * scaleX
   * @type {number}
   * @memberof TextTemplateContentItemAttrs
   */
  scaleX: number;
  /**
   * scaleY
   * @type {number}
   * @memberof TextTemplateContentItemAttrs
   */
  scaleY: number;
  /**
   * x
   * @type {number}
   * @memberof TextTemplateContentItemAttrs
   */
  x: number;
  /**
   * y
   * @type {number}
   * @memberof TextTemplateContentItemAttrs
   */
  y: number;
  /**
   * fill
   * @type {string}
   * @memberof TextTemplateContentItemAttrs
   */
  fill: string;
  /**
   * width
   * @type {number}
   * @memberof TextTemplateContentItemAttrs
   */
  width: number;
  /**
   * rotation
   * @type {number}
   * @memberof TextTemplateContentItemAttrs
   */
  rotation?: number;
}
/**
 * Text template, texts array
 * @export
 * @interface TextTemplateData
 */
export interface TextTemplateData {
  /**
   * Content field
   * @type {Array<TextTemplateContentItem>}
   * @memberof TextTemplateData
   */
  content?: Array<TextTemplateContentItem>;
}
/**
 * Text template item
 * @export
 * @interface TextTemplateItem
 */
export interface TextTemplateItem {
  /**
   *
   * @type {TextTemplateData}
   * @memberof TextTemplateItem
   */
  data?: TextTemplateData;
}
/**
 * Text template
 * @export
 * @interface TextTemplateResponse
 */
export interface TextTemplateResponse {
  /**
   *
   * @type {TextTemplateItem}
   * @memberof TextTemplateResponse
   */
  response: TextTemplateItem;
  /**
   * Status
   * @type {boolean}
   * @memberof TextTemplateResponse
   */
  status: boolean;
}
/**
 * Media object geometry transformations.
 * @export
 * @interface Transform
 */
export interface Transform {
  /**
   *
   * @type {ScalingModeEnum}
   * @memberof Transform
   */
  scale_auto?: ScalingModeEnum;
  /**
   * Layer position on canvas, in pixels.
   * @type {Position}
   * @memberof Transform
   */
  position?: Position;
  /**
   * Layer rotation angle in diapason [0, 180] degrees, negative values possible.
   * @type {number}
   * @memberof Transform
   */
  rotation?: number;
  /**
   * Scale by wight and height parameters. Wight and height refer to Vec model like vec.x and vec.y respectively.
   * @type {Position}
   * @memberof Transform
   */
  resize?: Position;
}
/**
 * Describes a transition between the videos or images
 * @export
 * @interface Transition
 */
export interface Transition {
  /**
   * Transition type.
   * @type {string}
   * @memberof Transition
   */
  type: TransitionTypeEnum;
  /**
   * Direction for the `wipe` transition.
   * @type {string}
   * @memberof Transition
   */
  transition_direction?: TransitionTransitionDirectionEnum;
  /**
   * URL for the transparent video (used only for type == custom_shape)
   * @type {string}
   * @memberof Transition
   */
  url?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum TransitionTypeEnum {
  Fade = 'fade',
  WipeDiagonal = 'wipe_diagonal',
  Shape = 'shape'
}
/**
 * @export
 * @enum {string}
 */
export enum TransitionTransitionDirectionEnum {
  Top = 'top',
  Right = 'right',
  Bottom = 'bottom',
  Left = 'left',
  TopLeft = 'top_left',
  TopRight = 'top_right',
  BottomLeft = 'bottom_left',
  BottomRight = 'bottom_right'
}

/**
 * Describes transitions backend settings
 * @export
 * @interface TransitionSettings
 */
export interface TransitionSettings {
  /**
   * Duration of Fade transition in seconds
   * @type {number}
   * @memberof TransitionSettings
   */
  fadeDuration: number;
  /**
   * Duration of Wipe Diagonal transition in seconds
   * @type {number}
   * @memberof TransitionSettings
   */
  wipeDiagonalDuration: number;
}
/**
 * Adds trimming information to the ContentItem (video, audio)
 * @export
 * @interface TrimmedContentItem
 */
export interface TrimmedContentItem extends ContentItem {
  /**
   * Start of the trimmed area in ms from the beginning of the video/audio
   * @type {number}
   * @memberof TrimmedContentItem
   */
  trimStart?: number;
  /**
   * Duration of the trimmed area in ms
   * @type {number}
   * @memberof TrimmedContentItem
   */
  trimDuration?: number;
}
/**
 * describes schema validation error
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
  /**
   * path to element where schema is violated
   * @type {Array<string>}
   * @memberof ValidationError
   */
  loc: Array<string>;
  /**
   * validation error message
   * @type {string}
   * @memberof ValidationError
   */
  msg: string;
  /**
   * validation error type
   * @type {string}
   * @memberof ValidationError
   */
  type: string;
}
/**
 * Size and url of video
 * @export
 * @interface VideoDescription
 */
export interface VideoDescription extends Dimensions {
  /**
   * Url to CDN
   * @type {string}
   * @memberof VideoDescription
   */
  url: string;
}
/**
 * Describes the container (and codec) of output video
 * @export
 * @enum {string}
 */
export enum VideoFileContainerEnum {
  Mp4 = 'mp4',
  Webm = 'webm'
}

/**
 * BackendV2Api - axios parameter creator
 * @export
 */
export const BackendV2ApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * create task to convert video to MP4
     * @summary create preprocessing task
     * @param {PreprocessingTask} preprocessingTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPreprocessingTaskV3(
      preprocessingTask: PreprocessingTask,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'preprocessingTask' is not null or undefined
      if (preprocessingTask === null || preprocessingTask === undefined) {
        throw new RequiredError(
          'preprocessingTask',
          'Required parameter preprocessingTask was null or undefined when calling createPreprocessingTaskV3.'
        );
      }
      const localVarPath = '/web-video-editor-v2/v3/preprocessing';
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('x-api-key')
            : configuration.apiKey;
        localVarHeaderParameter['x-api-key'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      const headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };
      const needsSerialization =
        typeof preprocessingTask !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(preprocessingTask !== undefined ? preprocessingTask : {})
        : preprocessingTask || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * create task to convert original video to 720p and PUT to stockvideo API
     * @summary create task for stockvideo
     * @param {string} videoId ID of a stockvideo item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createStockvideoTaskV3(videoId: string, options: any = {}): RequestArgs {
      // verify required parameter 'videoId' is not null or undefined
      if (videoId === null || videoId === undefined) {
        throw new RequiredError(
          'videoId',
          'Required parameter videoId was null or undefined when calling createStockvideoTaskV3.'
        );
      }
      const localVarPath = '/web-video-editor-v2/v3/stockvideo/{video_id}'.replace(
        `{${'video_id'}}`,
        encodeURIComponent(String(videoId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('x-api-key')
            : configuration.apiKey;
        localVarHeaderParameter['x-api-key'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      const headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Start processing task asynchronously and return task id
     * @summary create processing task
     * @param {ProcessingTask} processingTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTaskV3(processingTask: ProcessingTask, options: any = {}): RequestArgs {
      // verify required parameter 'processingTask' is not null or undefined
      if (processingTask === null || processingTask === undefined) {
        throw new RequiredError(
          'processingTask',
          'Required parameter processingTask was null or undefined when calling createTaskV3.'
        );
      }
      const localVarPath = '/web-video-editor-v2/v3/tasks';
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('x-api-key')
            : configuration.apiKey;
        localVarHeaderParameter['x-api-key'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      const headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };
      const needsSerialization =
        typeof processingTask !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(processingTask !== undefined ? processingTask : {})
        : processingTask || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Cancels task
     * @summary Delete Task
     * @param {string} taskId ID of a processing task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTaskByIdV3(taskId: string, options: any = {}): RequestArgs {
      // verify required parameter 'taskId' is not null or undefined
      if (taskId === null || taskId === undefined) {
        throw new RequiredError(
          'taskId',
          'Required parameter taskId was null or undefined when calling deleteTaskByIdV3.'
        );
      }
      const localVarPath = '/web-video-editor-v2/v3/tasks/{task_id}'.replace(
        `{${'task_id'}}`,
        encodeURIComponent(String(taskId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('x-api-key')
            : configuration.apiKey;
        localVarHeaderParameter['x-api-key'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      const headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Returns backend settings
     * @summary Returns settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBackendSettingsV3(options: any = {}): RequestArgs {
      const localVarPath = '/web-video-editor-v2/v3/settings';
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('x-api-key')
            : configuration.apiKey;
        localVarHeaderParameter['x-api-key'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      const headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Returns task processing status
     * @summary Get task status
     * @param {string} taskId ID of a processing task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTaskByIdV3(taskId: string, options: any = {}): RequestArgs {
      // verify required parameter 'taskId' is not null or undefined
      if (taskId === null || taskId === undefined) {
        throw new RequiredError(
          'taskId',
          'Required parameter taskId was null or undefined when calling getTaskByIdV3.'
        );
      }
      const localVarPath = '/web-video-editor-v2/v3/tasks/{task_id}'.replace(
        `{${'task_id'}}`,
        encodeURIComponent(String(taskId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('x-api-key')
            : configuration.apiKey;
        localVarHeaderParameter['x-api-key'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      const headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};

/**
 * BackendV2Api - functional programming interface
 * @export
 */
export const BackendV2ApiFp = function (configuration?: Configuration) {
  return {
    /**
     * create task to convert video to MP4
     * @summary create preprocessing task
     * @param {PreprocessingTask} preprocessingTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPreprocessingTaskV3(
      preprocessingTask: PreprocessingTask,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Task> {
      const localVarAxiosArgs = BackendV2ApiAxiosParamCreator(
        configuration
      ).createPreprocessingTaskV3(preprocessingTask, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * create task to convert original video to 720p and PUT to stockvideo API
     * @summary create task for stockvideo
     * @param {string} videoId ID of a stockvideo item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createStockvideoTaskV3(
      videoId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Task> {
      const localVarAxiosArgs = BackendV2ApiAxiosParamCreator(configuration).createStockvideoTaskV3(
        videoId,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * Start processing task asynchronously and return task id
     * @summary create processing task
     * @param {ProcessingTask} processingTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTaskV3(
      processingTask: ProcessingTask,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Task> {
      const localVarAxiosArgs = BackendV2ApiAxiosParamCreator(configuration).createTaskV3(
        processingTask,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * Cancels task
     * @summary Delete Task
     * @param {string} taskId ID of a processing task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTaskByIdV3(
      taskId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
      const localVarAxiosArgs = BackendV2ApiAxiosParamCreator(configuration).deleteTaskByIdV3(
        taskId,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * Returns backend settings
     * @summary Returns settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBackendSettingsV3(
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackendSettings> {
      const localVarAxiosArgs = BackendV2ApiAxiosParamCreator(configuration).getBackendSettingsV3(
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * Returns task processing status
     * @summary Get task status
     * @param {string} taskId ID of a processing task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTaskByIdV3(
      taskId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessingTaskStatus> {
      const localVarAxiosArgs = BackendV2ApiAxiosParamCreator(configuration).getTaskByIdV3(
        taskId,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    }
  };
};

/**
 * BackendV2Api - factory interface
 * @export
 */
export const BackendV2ApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * create task to convert video to MP4
     * @summary create preprocessing task
     * @param {PreprocessingTask} preprocessingTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPreprocessingTaskV3(
      preprocessingTask: PreprocessingTask,
      options?: any
    ): AxiosPromise<Task> {
      return BackendV2ApiFp(configuration).createPreprocessingTaskV3(preprocessingTask, options)(
        axios,
        basePath
      );
    },
    /**
     * create task to convert original video to 720p and PUT to stockvideo API
     * @summary create task for stockvideo
     * @param {string} videoId ID of a stockvideo item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createStockvideoTaskV3(videoId: string, options?: any): AxiosPromise<Task> {
      return BackendV2ApiFp(configuration).createStockvideoTaskV3(videoId, options)(
        axios,
        basePath
      );
    },
    /**
     * Start processing task asynchronously and return task id
     * @summary create processing task
     * @param {ProcessingTask} processingTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTaskV3(processingTask: ProcessingTask, options?: any): AxiosPromise<Task> {
      return BackendV2ApiFp(configuration).createTaskV3(processingTask, options)(axios, basePath);
    },
    /**
     * Cancels task
     * @summary Delete Task
     * @param {string} taskId ID of a processing task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTaskByIdV3(taskId: string, options?: any): AxiosPromise<void> {
      return BackendV2ApiFp(configuration).deleteTaskByIdV3(taskId, options)(axios, basePath);
    },
    /**
     * Returns backend settings
     * @summary Returns settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBackendSettingsV3(options?: any): AxiosPromise<BackendSettings> {
      return BackendV2ApiFp(configuration).getBackendSettingsV3(options)(axios, basePath);
    },
    /**
     * Returns task processing status
     * @summary Get task status
     * @param {string} taskId ID of a processing task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTaskByIdV3(taskId: string, options?: any): AxiosPromise<ProcessingTaskStatus> {
      return BackendV2ApiFp(configuration).getTaskByIdV3(taskId, options)(axios, basePath);
    }
  };
};

/**
 * BackendV2Api - object-oriented interface
 * @export
 * @class BackendV2Api
 * @extends {BaseAPI}
 */
export class BackendV2Api extends BaseAPI {
  /**
   * create task to convert video to MP4
   * @summary create preprocessing task
   * @param {PreprocessingTask} preprocessingTask
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackendV2Api
   */
  public createPreprocessingTaskV3(preprocessingTask: PreprocessingTask, options?: any) {
    return BackendV2ApiFp(this.configuration).createPreprocessingTaskV3(preprocessingTask, options)(
      this.axios,
      this.basePath
    );
  }

  /**
   * create task to convert original video to 720p and PUT to stockvideo API
   * @summary create task for stockvideo
   * @param {string} videoId ID of a stockvideo item
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackendV2Api
   */
  public createStockvideoTaskV3(videoId: string, options?: any) {
    return BackendV2ApiFp(this.configuration).createStockvideoTaskV3(videoId, options)(
      this.axios,
      this.basePath
    );
  }

  /**
   * Start processing task asynchronously and return task id
   * @summary create processing task
   * @param {ProcessingTask} processingTask
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackendV2Api
   */
  public createTaskV3(processingTask: ProcessingTask, options?: any) {
    return BackendV2ApiFp(this.configuration).createTaskV3(processingTask, options)(
      this.axios,
      this.basePath
    );
  }

  /**
   * Cancels task
   * @summary Delete Task
   * @param {string} taskId ID of a processing task
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackendV2Api
   */
  public deleteTaskByIdV3(taskId: string, options?: any) {
    return BackendV2ApiFp(this.configuration).deleteTaskByIdV3(taskId, options)(
      this.axios,
      this.basePath
    );
  }

  /**
   * Returns backend settings
   * @summary Returns settings
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackendV2Api
   */
  public getBackendSettingsV3(options?: any) {
    return BackendV2ApiFp(this.configuration).getBackendSettingsV3(options)(
      this.axios,
      this.basePath
    );
  }

  /**
   * Returns task processing status
   * @summary Get task status
   * @param {string} taskId ID of a processing task
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackendV2Api
   */
  public getTaskByIdV3(taskId: string, options?: any) {
    return BackendV2ApiFp(this.configuration).getTaskByIdV3(taskId, options)(
      this.axios,
      this.basePath
    );
  }
}

/**
 * ContentApi - axios parameter creator
 * @export
 */
export const ContentApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Uploads a content item (picture, video, audio) into the CDN
     * @summary Uploads content
     * @param {string} type Type is a way of categorizing files e.g. draft-project-files, replay-files...
     * @param {any} [file] file to upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addContent(type: string, file?: any, options: any = {}): RequestArgs {
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          'type',
          'Required parameter type was null or undefined when calling addContent.'
        );
      }
      const localVarPath = '/files';
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new FormData();

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('x-api-key')
            : configuration.apiKey;
        localVarHeaderParameter['x-api-key'] = localVarApiKeyValue;
      }

      if (type !== undefined) {
        localVarFormParams.append('type', type as any);
      }

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      const headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};

/**
 * ContentApi - functional programming interface
 * @export
 */
export const ContentApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Uploads a content item (picture, video, audio) into the CDN
     * @summary Uploads content
     * @param {string} type Type is a way of categorizing files e.g. draft-project-files, replay-files...
     * @param {any} [file] file to upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addContent(
      type: string,
      file?: any,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddContentResponse> {
      const localVarAxiosArgs = ContentApiAxiosParamCreator(configuration).addContent(
        type,
        file,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    }
  };
};

/**
 * ContentApi - factory interface
 * @export
 */
export const ContentApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Uploads a content item (picture, video, audio) into the CDN
     * @summary Uploads content
     * @param {string} type Type is a way of categorizing files e.g. draft-project-files, replay-files...
     * @param {any} [file] file to upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addContent(type: string, file?: any, options?: any): AxiosPromise<AddContentResponse> {
      return ContentApiFp(configuration).addContent(type, file, options)(axios, basePath);
    }
  };
};

/**
 * ContentApi - object-oriented interface
 * @export
 * @class ContentApi
 * @extends {BaseAPI}
 */
export class ContentApi extends BaseAPI {
  /**
   * Uploads a content item (picture, video, audio) into the CDN
   * @summary Uploads content
   * @param {string} type Type is a way of categorizing files e.g. draft-project-files, replay-files...
   * @param {any} [file] file to upload
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContentApi
   */
  public addContent(type: string, file?: any, options?: any) {
    return ContentApiFp(this.configuration).addContent(
      type,
      file,
      options
    )(this.axios, this.basePath);
  }
}

/**
 * PicsartApi - axios parameter creator
 * @export
 */
export const PicsartApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Text template
     * @summary Text template
     * @param {string} templateId templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTextTemplate(templateId: string, options: any = {}): RequestArgs {
      // verify required parameter 'templateId' is not null or undefined
      if (templateId === null || templateId === undefined) {
        throw new RequiredError(
          'templateId',
          'Required parameter templateId was null or undefined when calling getTextTemplate.'
        );
      }
      const localVarPath = '/templates/{templateId}'.replace(
        `{${'templateId'}}`,
        encodeURIComponent(String(templateId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('x-api-key')
            : configuration.apiKey;
        localVarHeaderParameter['x-api-key'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      const headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};

/**
 * PicsartApi - functional programming interface
 * @export
 */
export const PicsartApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Text template
     * @summary Text template
     * @param {string} templateId templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTextTemplate(
      templateId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TextTemplateResponse> {
      const localVarAxiosArgs = PicsartApiAxiosParamCreator(configuration).getTextTemplate(
        templateId,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    }
  };
};

/**
 * PicsartApi - factory interface
 * @export
 */
export const PicsartApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Text template
     * @summary Text template
     * @param {string} templateId templateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTextTemplate(templateId: string, options?: any): AxiosPromise<TextTemplateResponse> {
      return PicsartApiFp(configuration).getTextTemplate(templateId, options)(axios, basePath);
    }
  };
};

/**
 * PicsartApi - object-oriented interface
 * @export
 * @class PicsartApi
 * @extends {BaseAPI}
 */
export class PicsartApi extends BaseAPI {
  /**
   * Text template
   * @summary Text template
   * @param {string} templateId templateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PicsartApi
   */
  public getTextTemplate(templateId: string, options?: any) {
    return PicsartApiFp(this.configuration).getTextTemplate(templateId, options)(
      this.axios,
      this.basePath
    );
  }
}

/**
 * PicsartLiveApi - axios parameter creator
 * @export
 */
export const PicsartLiveApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Shutterstock image by id
     * @summary Shutterstock image by id
     * @param {string} ids Id of original image in Shutterstock
     * @param {string} [searchIds] Id of the search
     * @param {'view'} [action] action&#x3D;view means we are licensing the image but still user needs to download it to be counted as used in backend
     * @param {'website'} [platform] Platform
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getShutterstockImageUrlById(
      ids: string,
      searchIds?: string,
      action?: 'view',
      platform?: 'website',
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'ids' is not null or undefined
      if (ids === null || ids === undefined) {
        throw new RequiredError(
          'ids',
          'Required parameter ids was null or undefined when calling getShutterstockImageUrlById.'
        );
      }
      const localVarPath = '/photos/shutterstock/url';
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('x-api-key')
            : configuration.apiKey;
        localVarHeaderParameter['x-api-key'] = localVarApiKeyValue;
      }

      if (ids !== undefined) {
        localVarQueryParameter.ids = ids;
      }

      if (searchIds !== undefined) {
        localVarQueryParameter.search_ids = searchIds;
      }

      if (action !== undefined) {
        localVarQueryParameter.action = action;
      }

      if (platform !== undefined && platform !== null) {
        localVarHeaderParameter.platform = String(platform);
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      const headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};

/**
 * PicsartLiveApi - functional programming interface
 * @export
 */
export const PicsartLiveApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Shutterstock image by id
     * @summary Shutterstock image by id
     * @param {string} ids Id of original image in Shutterstock
     * @param {string} [searchIds] Id of the search
     * @param {'view'} [action] action&#x3D;view means we are licensing the image but still user needs to download it to be counted as used in backend
     * @param {'website'} [platform] Platform
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getShutterstockImageUrlById(
      ids: string,
      searchIds?: string,
      action?: 'view',
      platform?: 'website',
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShutterstockResponse> {
      const localVarAxiosArgs = PicsartLiveApiAxiosParamCreator(
        configuration
      ).getShutterstockImageUrlById(ids, searchIds, action, platform, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    }
  };
};

/**
 * PicsartLiveApi - factory interface
 * @export
 */
export const PicsartLiveApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Shutterstock image by id
     * @summary Shutterstock image by id
     * @param {string} ids Id of original image in Shutterstock
     * @param {string} [searchIds] Id of the search
     * @param {'view'} [action] action&#x3D;view means we are licensing the image but still user needs to download it to be counted as used in backend
     * @param {'website'} [platform] Platform
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getShutterstockImageUrlById(
      ids: string,
      searchIds?: string,
      action?: 'view',
      platform?: 'website',
      options?: any
    ): AxiosPromise<ShutterstockResponse> {
      return PicsartLiveApiFp(configuration).getShutterstockImageUrlById(
        ids,
        searchIds,
        action,
        platform,
        options
      )(axios, basePath);
    }
  };
};

/**
 * PicsartLiveApi - object-oriented interface
 * @export
 * @class PicsartLiveApi
 * @extends {BaseAPI}
 */
export class PicsartLiveApi extends BaseAPI {
  /**
   * Shutterstock image by id
   * @summary Shutterstock image by id
   * @param {string} ids Id of original image in Shutterstock
   * @param {string} [searchIds] Id of the search
   * @param {'view'} [action] action&#x3D;view means we are licensing the image but still user needs to download it to be counted as used in backend
   * @param {'website'} [platform] Platform
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PicsartLiveApi
   */
  public getShutterstockImageUrlById(
    ids: string,
    searchIds?: string,
    action?: 'view',
    platform?: 'website',
    options?: any
  ) {
    return PicsartLiveApiFp(this.configuration).getShutterstockImageUrlById(
      ids,
      searchIds,
      action,
      platform,
      options
    )(this.axios, this.basePath);
  }
}

/**
 * ProcessingApi - axios parameter creator
 * @export
 */
export const ProcessingApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Adds new preprocessing task
     * @summary Adds preprocessing task.
     * @param {PreprocessingTask} preprocessingTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPreprocessingTask(preprocessingTask: PreprocessingTask, options: any = {}): RequestArgs {
      // verify required parameter 'preprocessingTask' is not null or undefined
      if (preprocessingTask === null || preprocessingTask === undefined) {
        throw new RequiredError(
          'preprocessingTask',
          'Required parameter preprocessingTask was null or undefined when calling createPreprocessingTask.'
        );
      }
      const localVarPath = '/web-video-editor/preprocessing';
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('x-api-key')
            : configuration.apiKey;
        localVarHeaderParameter['x-api-key'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      const headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };
      const needsSerialization =
        typeof preprocessingTask !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(preprocessingTask !== undefined ? preprocessingTask : {})
        : preprocessingTask || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * create task to convert video to MP4
     * @summary create preprocessing task
     * @param {PreprocessingTask} preprocessingTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPreprocessingTaskV3(
      preprocessingTask: PreprocessingTask,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'preprocessingTask' is not null or undefined
      if (preprocessingTask === null || preprocessingTask === undefined) {
        throw new RequiredError(
          'preprocessingTask',
          'Required parameter preprocessingTask was null or undefined when calling createPreprocessingTaskV3.'
        );
      }
      const localVarPath = '/web-video-editor-v2/v3/preprocessing';
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('x-api-key')
            : configuration.apiKey;
        localVarHeaderParameter['x-api-key'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      const headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };
      const needsSerialization =
        typeof preprocessingTask !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(preprocessingTask !== undefined ? preprocessingTask : {})
        : preprocessingTask || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * create task to convert original video to 720p and PUT to stockvideo API
     * @summary create task for stockvideo
     * @param {string} videoId ID of a stockvideo item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createStockvideoTaskV3(videoId: string, options: any = {}): RequestArgs {
      // verify required parameter 'videoId' is not null or undefined
      if (videoId === null || videoId === undefined) {
        throw new RequiredError(
          'videoId',
          'Required parameter videoId was null or undefined when calling createStockvideoTaskV3.'
        );
      }
      const localVarPath = '/web-video-editor-v2/v3/stockvideo/{video_id}'.replace(
        `{${'video_id'}}`,
        encodeURIComponent(String(videoId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('x-api-key')
            : configuration.apiKey;
        localVarHeaderParameter['x-api-key'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      const headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Adds new processing task
     * @summary Adds processing task.
     * @param {ProcessingTask} processingTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTask(processingTask: ProcessingTask, options: any = {}): RequestArgs {
      // verify required parameter 'processingTask' is not null or undefined
      if (processingTask === null || processingTask === undefined) {
        throw new RequiredError(
          'processingTask',
          'Required parameter processingTask was null or undefined when calling createTask.'
        );
      }
      const localVarPath = '/web-video-editor/tasks';
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('x-api-key')
            : configuration.apiKey;
        localVarHeaderParameter['x-api-key'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      const headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };
      const needsSerialization =
        typeof processingTask !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(processingTask !== undefined ? processingTask : {})
        : processingTask || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Start processing task asynchronously and return task id
     * @summary create processing task
     * @param {ProcessingTask} processingTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTaskV3(processingTask: ProcessingTask, options: any = {}): RequestArgs {
      // verify required parameter 'processingTask' is not null or undefined
      if (processingTask === null || processingTask === undefined) {
        throw new RequiredError(
          'processingTask',
          'Required parameter processingTask was null or undefined when calling createTaskV3.'
        );
      }
      const localVarPath = '/web-video-editor-v2/v3/tasks';
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('x-api-key')
            : configuration.apiKey;
        localVarHeaderParameter['x-api-key'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      const headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };
      const needsSerialization =
        typeof processingTask !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(processingTask !== undefined ? processingTask : {})
        : processingTask || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Cancels task processing
     * @summary Cancel task.
     * @param {string} taskId ID of the task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTaskById(taskId: string, options: any = {}): RequestArgs {
      // verify required parameter 'taskId' is not null or undefined
      if (taskId === null || taskId === undefined) {
        throw new RequiredError(
          'taskId',
          'Required parameter taskId was null or undefined when calling deleteTaskById.'
        );
      }
      const localVarPath = '/web-video-editor/tasks/{taskId}'.replace(
        `{${'taskId'}}`,
        encodeURIComponent(String(taskId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('x-api-key')
            : configuration.apiKey;
        localVarHeaderParameter['x-api-key'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      const headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Cancels task
     * @summary Delete Task
     * @param {string} taskId ID of a processing task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTaskByIdV3(taskId: string, options: any = {}): RequestArgs {
      // verify required parameter 'taskId' is not null or undefined
      if (taskId === null || taskId === undefined) {
        throw new RequiredError(
          'taskId',
          'Required parameter taskId was null or undefined when calling deleteTaskByIdV3.'
        );
      }
      const localVarPath = '/web-video-editor-v2/v3/tasks/{task_id}'.replace(
        `{${'task_id'}}`,
        encodeURIComponent(String(taskId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('x-api-key')
            : configuration.apiKey;
        localVarHeaderParameter['x-api-key'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      const headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Returns task processing status
     * @summary Get task status.
     * @param {string} taskId ID of the task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTaskById(taskId: string, options: any = {}): RequestArgs {
      // verify required parameter 'taskId' is not null or undefined
      if (taskId === null || taskId === undefined) {
        throw new RequiredError(
          'taskId',
          'Required parameter taskId was null or undefined when calling getTaskById.'
        );
      }
      const localVarPath = '/web-video-editor/tasks/{taskId}'.replace(
        `{${'taskId'}}`,
        encodeURIComponent(String(taskId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('x-api-key')
            : configuration.apiKey;
        localVarHeaderParameter['x-api-key'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      const headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Returns task processing status
     * @summary Get task status
     * @param {string} taskId ID of a processing task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTaskByIdV3(taskId: string, options: any = {}): RequestArgs {
      // verify required parameter 'taskId' is not null or undefined
      if (taskId === null || taskId === undefined) {
        throw new RequiredError(
          'taskId',
          'Required parameter taskId was null or undefined when calling getTaskByIdV3.'
        );
      }
      const localVarPath = '/web-video-editor-v2/v3/tasks/{task_id}'.replace(
        `{${'task_id'}}`,
        encodeURIComponent(String(taskId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('x-api-key')
            : configuration.apiKey;
        localVarHeaderParameter['x-api-key'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      const headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};

/**
 * ProcessingApi - functional programming interface
 * @export
 */
export const ProcessingApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Adds new preprocessing task
     * @summary Adds preprocessing task.
     * @param {PreprocessingTask} preprocessingTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPreprocessingTask(
      preprocessingTask: PreprocessingTask,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Task> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(
        configuration
      ).createPreprocessingTask(preprocessingTask, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * create task to convert video to MP4
     * @summary create preprocessing task
     * @param {PreprocessingTask} preprocessingTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPreprocessingTaskV3(
      preprocessingTask: PreprocessingTask,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Task> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(
        configuration
      ).createPreprocessingTaskV3(preprocessingTask, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * create task to convert original video to 720p and PUT to stockvideo API
     * @summary create task for stockvideo
     * @param {string} videoId ID of a stockvideo item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createStockvideoTaskV3(
      videoId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Task> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(
        configuration
      ).createStockvideoTaskV3(videoId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * Adds new processing task
     * @summary Adds processing task.
     * @param {ProcessingTask} processingTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTask(
      processingTask: ProcessingTask,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Task> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(configuration).createTask(
        processingTask,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * Start processing task asynchronously and return task id
     * @summary create processing task
     * @param {ProcessingTask} processingTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTaskV3(
      processingTask: ProcessingTask,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Task> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(configuration).createTaskV3(
        processingTask,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * Cancels task processing
     * @summary Cancel task.
     * @param {string} taskId ID of the task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTaskById(
      taskId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(configuration).deleteTaskById(
        taskId,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * Cancels task
     * @summary Delete Task
     * @param {string} taskId ID of a processing task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTaskByIdV3(
      taskId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(configuration).deleteTaskByIdV3(
        taskId,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * Returns task processing status
     * @summary Get task status.
     * @param {string} taskId ID of the task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTaskById(
      taskId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessingTaskStatus> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(configuration).getTaskById(
        taskId,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * Returns task processing status
     * @summary Get task status
     * @param {string} taskId ID of a processing task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTaskByIdV3(
      taskId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessingTaskStatus> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(configuration).getTaskByIdV3(
        taskId,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    }
  };
};

/**
 * ProcessingApi - factory interface
 * @export
 */
export const ProcessingApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Adds new preprocessing task
     * @summary Adds preprocessing task.
     * @param {PreprocessingTask} preprocessingTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPreprocessingTask(
      preprocessingTask: PreprocessingTask,
      options?: any
    ): AxiosPromise<Task> {
      return ProcessingApiFp(configuration).createPreprocessingTask(preprocessingTask, options)(
        axios,
        basePath
      );
    },
    /**
     * create task to convert video to MP4
     * @summary create preprocessing task
     * @param {PreprocessingTask} preprocessingTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPreprocessingTaskV3(
      preprocessingTask: PreprocessingTask,
      options?: any
    ): AxiosPromise<Task> {
      return ProcessingApiFp(configuration).createPreprocessingTaskV3(preprocessingTask, options)(
        axios,
        basePath
      );
    },
    /**
     * create task to convert original video to 720p and PUT to stockvideo API
     * @summary create task for stockvideo
     * @param {string} videoId ID of a stockvideo item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createStockvideoTaskV3(videoId: string, options?: any): AxiosPromise<Task> {
      return ProcessingApiFp(configuration).createStockvideoTaskV3(videoId, options)(
        axios,
        basePath
      );
    },
    /**
     * Adds new processing task
     * @summary Adds processing task.
     * @param {ProcessingTask} processingTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTask(processingTask: ProcessingTask, options?: any): AxiosPromise<Task> {
      return ProcessingApiFp(configuration).createTask(processingTask, options)(axios, basePath);
    },
    /**
     * Start processing task asynchronously and return task id
     * @summary create processing task
     * @param {ProcessingTask} processingTask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTaskV3(processingTask: ProcessingTask, options?: any): AxiosPromise<Task> {
      return ProcessingApiFp(configuration).createTaskV3(processingTask, options)(axios, basePath);
    },
    /**
     * Cancels task processing
     * @summary Cancel task.
     * @param {string} taskId ID of the task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTaskById(taskId: string, options?: any): AxiosPromise<void> {
      return ProcessingApiFp(configuration).deleteTaskById(taskId, options)(axios, basePath);
    },
    /**
     * Cancels task
     * @summary Delete Task
     * @param {string} taskId ID of a processing task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTaskByIdV3(taskId: string, options?: any): AxiosPromise<void> {
      return ProcessingApiFp(configuration).deleteTaskByIdV3(taskId, options)(axios, basePath);
    },
    /**
     * Returns task processing status
     * @summary Get task status.
     * @param {string} taskId ID of the task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTaskById(taskId: string, options?: any): AxiosPromise<ProcessingTaskStatus> {
      return ProcessingApiFp(configuration).getTaskById(taskId, options)(axios, basePath);
    },
    /**
     * Returns task processing status
     * @summary Get task status
     * @param {string} taskId ID of a processing task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTaskByIdV3(taskId: string, options?: any): AxiosPromise<ProcessingTaskStatus> {
      return ProcessingApiFp(configuration).getTaskByIdV3(taskId, options)(axios, basePath);
    }
  };
};

/**
 * ProcessingApi - object-oriented interface
 * @export
 * @class ProcessingApi
 * @extends {BaseAPI}
 */
export class ProcessingApi extends BaseAPI {
  /**
   * Adds new preprocessing task
   * @summary Adds preprocessing task.
   * @param {PreprocessingTask} preprocessingTask
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public createPreprocessingTask(preprocessingTask: PreprocessingTask, options?: any) {
    return ProcessingApiFp(this.configuration).createPreprocessingTask(preprocessingTask, options)(
      this.axios,
      this.basePath
    );
  }

  /**
   * create task to convert video to MP4
   * @summary create preprocessing task
   * @param {PreprocessingTask} preprocessingTask
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public createPreprocessingTaskV3(preprocessingTask: PreprocessingTask, options?: any) {
    return ProcessingApiFp(this.configuration).createPreprocessingTaskV3(
      preprocessingTask,
      options
    )(this.axios, this.basePath);
  }

  /**
   * create task to convert original video to 720p and PUT to stockvideo API
   * @summary create task for stockvideo
   * @param {string} videoId ID of a stockvideo item
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public createStockvideoTaskV3(videoId: string, options?: any) {
    return ProcessingApiFp(this.configuration).createStockvideoTaskV3(videoId, options)(
      this.axios,
      this.basePath
    );
  }

  /**
   * Adds new processing task
   * @summary Adds processing task.
   * @param {ProcessingTask} processingTask
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public createTask(processingTask: ProcessingTask, options?: any) {
    return ProcessingApiFp(this.configuration).createTask(processingTask, options)(
      this.axios,
      this.basePath
    );
  }

  /**
   * Start processing task asynchronously and return task id
   * @summary create processing task
   * @param {ProcessingTask} processingTask
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public createTaskV3(processingTask: ProcessingTask, options?: any) {
    return ProcessingApiFp(this.configuration).createTaskV3(processingTask, options)(
      this.axios,
      this.basePath
    );
  }

  /**
   * Cancels task processing
   * @summary Cancel task.
   * @param {string} taskId ID of the task
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public deleteTaskById(taskId: string, options?: any) {
    return ProcessingApiFp(this.configuration).deleteTaskById(taskId, options)(
      this.axios,
      this.basePath
    );
  }

  /**
   * Cancels task
   * @summary Delete Task
   * @param {string} taskId ID of a processing task
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public deleteTaskByIdV3(taskId: string, options?: any) {
    return ProcessingApiFp(this.configuration).deleteTaskByIdV3(taskId, options)(
      this.axios,
      this.basePath
    );
  }

  /**
   * Returns task processing status
   * @summary Get task status.
   * @param {string} taskId ID of the task
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public getTaskById(taskId: string, options?: any) {
    return ProcessingApiFp(this.configuration).getTaskById(taskId, options)(
      this.axios,
      this.basePath
    );
  }

  /**
   * Returns task processing status
   * @summary Get task status
   * @param {string} taskId ID of a processing task
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public getTaskByIdV3(taskId: string, options?: any) {
    return ProcessingApiFp(this.configuration).getTaskByIdV3(taskId, options)(
      this.axios,
      this.basePath
    );
  }
}

/**
 * SettingsApi - axios parameter creator
 * @export
 */
export const SettingsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Returns backend settings
     * @summary Returns settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBackendSettings(options: any = {}): RequestArgs {
      const localVarPath = '/web-video-editor/settings';
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('x-api-key')
            : configuration.apiKey;
        localVarHeaderParameter['x-api-key'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      const headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     * Returns backend settings
     * @summary Returns settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBackendSettingsV3(options: any = {}): RequestArgs {
      const localVarPath = '/web-video-editor-v2/v3/settings';
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('x-api-key')
            : configuration.apiKey;
        localVarHeaderParameter['x-api-key'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      const headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};

/**
 * SettingsApi - functional programming interface
 * @export
 */
export const SettingsApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Returns backend settings
     * @summary Returns settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBackendSettings(
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackendSettings> {
      const localVarAxiosArgs = SettingsApiAxiosParamCreator(configuration).getBackendSettings(
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * Returns backend settings
     * @summary Returns settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBackendSettingsV3(
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackendSettings> {
      const localVarAxiosArgs = SettingsApiAxiosParamCreator(configuration).getBackendSettingsV3(
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    }
  };
};

/**
 * SettingsApi - factory interface
 * @export
 */
export const SettingsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Returns backend settings
     * @summary Returns settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBackendSettings(options?: any): AxiosPromise<BackendSettings> {
      return SettingsApiFp(configuration).getBackendSettings(options)(axios, basePath);
    },
    /**
     * Returns backend settings
     * @summary Returns settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBackendSettingsV3(options?: any): AxiosPromise<BackendSettings> {
      return SettingsApiFp(configuration).getBackendSettingsV3(options)(axios, basePath);
    }
  };
};

/**
 * SettingsApi - object-oriented interface
 * @export
 * @class SettingsApi
 * @extends {BaseAPI}
 */
export class SettingsApi extends BaseAPI {
  /**
   * Returns backend settings
   * @summary Returns settings.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SettingsApi
   */
  public getBackendSettings(options?: any) {
    return SettingsApiFp(this.configuration).getBackendSettings(options)(this.axios, this.basePath);
  }

  /**
   * Returns backend settings
   * @summary Returns settings
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SettingsApi
   */
  public getBackendSettingsV3(options?: any) {
    return SettingsApiFp(this.configuration).getBackendSettingsV3(options)(
      this.axios,
      this.basePath
    );
  }
}

/**
 * StockVideosApi - axios parameter creator
 * @export
 */
export const StockVideosApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * List of stock videos
     * @summary Returns list of stock videos
     * @param {number} [limit] The numbers of items to return
     * @param {number} [offset] The number of items to skip before starting to collect the result set
     * @param {string} [q] Search query
     * @param {'premium' | 'fte'} [license] Fte/Premium
     * @param {boolean} [commercial] Allowed for commercial use or not
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStockVideosList(
      limit?: number,
      offset?: number,
      q?: string,
      license?: 'premium' | 'fte',
      commercial?: boolean,
      options: any = {}
    ): RequestArgs {
      const localVarPath = '/video-editor-api/stock-videos';
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('x-api-key')
            : configuration.apiKey;
        localVarHeaderParameter['x-api-key'] = localVarApiKeyValue;
      }

      if (limit !== undefined) {
        localVarQueryParameter.limit = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter.offset = offset;
      }

      if (q !== undefined) {
        localVarQueryParameter.q = q;
      }

      if (license !== undefined) {
        localVarQueryParameter.license = license;
      }

      if (commercial !== undefined) {
        localVarQueryParameter.commercial = commercial;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      const headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};

/**
 * StockVideosApi - functional programming interface
 * @export
 */
export const StockVideosApiFp = function (configuration?: Configuration) {
  return {
    /**
     * List of stock videos
     * @summary Returns list of stock videos
     * @param {number} [limit] The numbers of items to return
     * @param {number} [offset] The number of items to skip before starting to collect the result set
     * @param {string} [q] Search query
     * @param {'premium' | 'fte'} [license] Fte/Premium
     * @param {boolean} [commercial] Allowed for commercial use or not
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStockVideosList(
      limit?: number,
      offset?: number,
      q?: string,
      license?: 'premium' | 'fte',
      commercial?: boolean,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockVideosList> {
      const localVarAxiosArgs = StockVideosApiAxiosParamCreator(configuration).getStockVideosList(
        limit,
        offset,
        q,
        license,
        commercial,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    }
  };
};

/**
 * StockVideosApi - factory interface
 * @export
 */
export const StockVideosApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * List of stock videos
     * @summary Returns list of stock videos
     * @param {number} [limit] The numbers of items to return
     * @param {number} [offset] The number of items to skip before starting to collect the result set
     * @param {string} [q] Search query
     * @param {'premium' | 'fte'} [license] Fte/Premium
     * @param {boolean} [commercial] Allowed for commercial use or not
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStockVideosList(
      limit?: number,
      offset?: number,
      q?: string,
      license?: 'premium' | 'fte',
      commercial?: boolean,
      options?: any
    ): AxiosPromise<StockVideosList> {
      return StockVideosApiFp(configuration).getStockVideosList(
        limit,
        offset,
        q,
        license,
        commercial,
        options
      )(axios, basePath);
    }
  };
};

/**
 * StockVideosApi - object-oriented interface
 * @export
 * @class StockVideosApi
 * @extends {BaseAPI}
 */
export class StockVideosApi extends BaseAPI {
  /**
   * List of stock videos
   * @summary Returns list of stock videos
   * @param {number} [limit] The numbers of items to return
   * @param {number} [offset] The number of items to skip before starting to collect the result set
   * @param {string} [q] Search query
   * @param {'premium' | 'fte'} [license] Fte/Premium
   * @param {boolean} [commercial] Allowed for commercial use or not
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StockVideosApi
   */
  public getStockVideosList(
    limit?: number,
    offset?: number,
    q?: string,
    license?: 'premium' | 'fte',
    commercial?: boolean,
    options?: any
  ) {
    return StockVideosApiFp(this.configuration).getStockVideosList(
      limit,
      offset,
      q,
      license,
      commercial,
      options
    )(this.axios, this.basePath);
  }
}

/**
 * TemplatesApi - axios parameter creator
 * @export
 */
export const TemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * List of templates
     * @summary List of templates
     * @param {number} [limit] The numbers of items to return
     * @param {number} [offset] The number of items to skip before starting to collect the result set
     * @param {string} [q] Search query
     * @param {'premium' | 'fte'} [license] Fte/Premium
     * @param {boolean} [commercial] Allowed for commercial use or not
     * @param {'youtube' | 'facebookSquare' | 'facebookPortrait' | 'facebookStory' | 'instagramSquare' | 'instagramPortrait' | 'instagramStory' | 'snapchat' | 'tiktok' | 'twitter'} [format] Aspect ratio format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTemplatesList(
      limit?: number,
      offset?: number,
      q?: string,
      license?: 'premium' | 'fte',
      commercial?: boolean,
      format?:
        | 'youtube'
        | 'facebookSquare'
        | 'facebookPortrait'
        | 'facebookStory'
        | 'instagramSquare'
        | 'instagramPortrait'
        | 'instagramStory'
        | 'snapchat'
        | 'tiktok'
        | 'twitter',
      options: any = {}
    ): RequestArgs {
      const localVarPath = '/video-editor-api/templates';
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKeyAuth required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('x-api-key')
            : configuration.apiKey;
        localVarHeaderParameter['x-api-key'] = localVarApiKeyValue;
      }

      if (limit !== undefined) {
        localVarQueryParameter.limit = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter.offset = offset;
      }

      if (q !== undefined) {
        localVarQueryParameter.q = q;
      }

      if (license !== undefined) {
        localVarQueryParameter.license = license;
      }

      if (commercial !== undefined) {
        localVarQueryParameter.commercial = commercial;
      }

      if (format !== undefined) {
        localVarQueryParameter.format = format;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      const headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};

/**
 * TemplatesApi - functional programming interface
 * @export
 */
export const TemplatesApiFp = function (configuration?: Configuration) {
  return {
    /**
     * List of templates
     * @summary List of templates
     * @param {number} [limit] The numbers of items to return
     * @param {number} [offset] The number of items to skip before starting to collect the result set
     * @param {string} [q] Search query
     * @param {'premium' | 'fte'} [license] Fte/Premium
     * @param {boolean} [commercial] Allowed for commercial use or not
     * @param {'youtube' | 'facebookSquare' | 'facebookPortrait' | 'facebookStory' | 'instagramSquare' | 'instagramPortrait' | 'instagramStory' | 'snapchat' | 'tiktok' | 'twitter'} [format] Aspect ratio format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTemplatesList(
      limit?: number,
      offset?: number,
      q?: string,
      license?: 'premium' | 'fte',
      commercial?: boolean,
      format?:
        | 'youtube'
        | 'facebookSquare'
        | 'facebookPortrait'
        | 'facebookStory'
        | 'instagramSquare'
        | 'instagramPortrait'
        | 'instagramStory'
        | 'snapchat'
        | 'tiktok'
        | 'twitter',
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplatesList> {
      const localVarAxiosArgs = TemplatesApiAxiosParamCreator(configuration).getTemplatesList(
        limit,
        offset,
        q,
        license,
        commercial,
        format,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url
        };
        return axios.request(axiosRequestArgs);
      };
    }
  };
};

/**
 * TemplatesApi - factory interface
 * @export
 */
export const TemplatesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * List of templates
     * @summary List of templates
     * @param {number} [limit] The numbers of items to return
     * @param {number} [offset] The number of items to skip before starting to collect the result set
     * @param {string} [q] Search query
     * @param {'premium' | 'fte'} [license] Fte/Premium
     * @param {boolean} [commercial] Allowed for commercial use or not
     * @param {'youtube' | 'facebookSquare' | 'facebookPortrait' | 'facebookStory' | 'instagramSquare' | 'instagramPortrait' | 'instagramStory' | 'snapchat' | 'tiktok' | 'twitter'} [format] Aspect ratio format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTemplatesList(
      limit?: number,
      offset?: number,
      q?: string,
      license?: 'premium' | 'fte',
      commercial?: boolean,
      format?:
        | 'youtube'
        | 'facebookSquare'
        | 'facebookPortrait'
        | 'facebookStory'
        | 'instagramSquare'
        | 'instagramPortrait'
        | 'instagramStory'
        | 'snapchat'
        | 'tiktok'
        | 'twitter',
      options?: any
    ): AxiosPromise<TemplatesList> {
      return TemplatesApiFp(configuration).getTemplatesList(
        limit,
        offset,
        q,
        license,
        commercial,
        format,
        options
      )(axios, basePath);
    }
  };
};

/**
 * TemplatesApi - object-oriented interface
 * @export
 * @class TemplatesApi
 * @extends {BaseAPI}
 */
export class TemplatesApi extends BaseAPI {
  /**
   * List of templates
   * @summary List of templates
   * @param {number} [limit] The numbers of items to return
   * @param {number} [offset] The number of items to skip before starting to collect the result set
   * @param {string} [q] Search query
   * @param {'premium' | 'fte'} [license] Fte/Premium
   * @param {boolean} [commercial] Allowed for commercial use or not
   * @param {'youtube' | 'facebookSquare' | 'facebookPortrait' | 'facebookStory' | 'instagramSquare' | 'instagramPortrait' | 'instagramStory' | 'snapchat' | 'tiktok' | 'twitter'} [format] Aspect ratio format
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TemplatesApi
   */
  public getTemplatesList(
    limit?: number,
    offset?: number,
    q?: string,
    license?: 'premium' | 'fte',
    commercial?: boolean,
    format?:
      | 'youtube'
      | 'facebookSquare'
      | 'facebookPortrait'
      | 'facebookStory'
      | 'instagramSquare'
      | 'instagramPortrait'
      | 'instagramStory'
      | 'snapchat'
      | 'tiktok'
      | 'twitter',
    options?: any
  ) {
    return TemplatesApiFp(this.configuration).getTemplatesList(
      limit,
      offset,
      q,
      license,
      commercial,
      format,
      options
    )(this.axios, this.basePath);
  }
}
